import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-invoice-eft-request-dialog',
  templateUrl: './invoice-eft-request-dialog.component.html',
  styleUrls: ['./invoice-eft-request-dialog.component.scss']
})
export class InvoiceEftRequestDialogComponent implements OnInit {
  invoice = {
    invoiceNumber: '',
    invoiceAmount: 0,
    invoiceBalance: 0,
    salesOrderNumber: '',
    depositBalance: 0,
    customerCode: '',
    customerAccountBalance: 0
  };
  stores: any[] = [];
  banks: any[] = [];
  form: FormGroup;
   refundReasons:{
    refundReasonId: number;
    refundReasonDesc: string;
  }[] = [];

  constructor(
    public dialogRef: MatDialogRef<InvoiceEftRequestDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private fb: FormBuilder
  ) {
    this.invoice = data;
    this.form = fb.group({
      invoiceNumber: [null, Validators.compose([Validators.required])],
      storeId: [null, Validators.compose([Validators.required])],
      amount: [null],
      bank: [null, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
      branchCode: [null, Validators.compose([Validators.minLength(1), Validators.maxLength(10)])],
      accountNumber: [null, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(20)])],
      refundReasonId: [null, Validators.compose([Validators.required])],
      comment: [null, Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(200)])],
    });
  }

  ngOnInit() {
    this.form.controls['invoiceNumber'].setValue(this.invoice.invoiceNumber);
    this.form.controls['amount'].setValue(0);
    this.form.controls['amount'].setValidators([Validators.required, Validators.min(1), Validators.max(this.invoice.invoiceBalance * -1)]);

    this.baseService.executeCommand<any>('portal_syspro_invoice_eft_request_dialog_config', this.data)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.stores = response.data.stores;
          this.banks = response.data.banks;
          this.refundReasons = response.data.refundReasons || [];
          if (this.stores && this.stores.length === 1) {
            this.form.controls['storeId'].setValue(this.stores[0].storeId);
          }
          if (this.banks && this.banks.length === 1) {
            this.form.controls['bank'].setValue(this.banks[0].bank);
          }
          if (this.refundReasons && this.refundReasons.length === 1) {
            this.form.controls['refundReasonId'].setValue(this.refundReasons[0].refundReasonId);
          }
        }
      });
  }

  save() {
    this.dialogRef.close(this.form.value);
  }

  amountTenderedChanged() {
    // const amount = +this.form.value.amount || 0;
    // this.form.controls['amount'].setValue(+amount.toFixed(2));
  }

  amountTenderedFocusOut() {
    const amount = +this.form.value.amount || 0;
    this.form.controls['amount'].setValue(+amount.toFixed(2));
  }


  onBankSelectionChange(event: any) {
      this.form.controls['bank'].setValue(event.value.bank);
      this.form.controls['branchCode'].setValue(event.value.branchCode);

      this.form.updateValueAndValidity({onlySelf: false});
  }

}
